import React, { useEffect, useState } from 'react'

import { useHistory, useParams } from 'react-router-dom'
import { reverse } from 'named-urls'
import {
  Box,
  Button,
  InputAdornment,
  TextField,
  Tooltip,
} from '@material-ui/core'
import {
  HelpCircle as HelpCircleIcon,
  PlusCircle as PlusCircleIcon,
  Search as SearchIcon,
} from 'react-feather'

import { Container, ContentHeader, GuestDriveTour, Page } from 'components'
import { PrivacyByDesignTable } from 'views/PrivacyByDesign/components'
import ActionButtons from '../components/ActionButtons'

import * as service from 'service'
import constants from 'constants/index'
import { routes } from 'GuestRoutes'
import useStyles from './styles'
import {
  PRIVACY_BY_DESIGN_TUTORIAL_STEP_1,
  PRIVACY_BY_DESIGN_TUTORIAL_STEP_2,
  PRIVACY_BY_DESIGN_TUTORIAL_STEP_3,
  PRIVACY_BY_DESIGN_TUTORIAL_STEP_4,
  PRIVACY_BY_DESIGN_TUTORIAL_STEP_5,
  privacyByDesignTutorialSteps,
} from './driverSteps'

const SEARCH_DELAY = 500

const PrivacyByDesignList = () => {
  const [searchQuery, setSearchQuery] = useState('')
  // A busca é filtrada pela API, então o valor digitado só vira parâmetro depois
  // de uma pausa — sem isso cada tecla dispararia uma requisição.
  const [searchParam, setSearchParam] = useState('')
  const [openTour, setOpenTour] = useState(false)

  const classes = useStyles()
  const history = useHistory()
  const { organizationSlug } = useParams()

  const redirectToCreate = () =>
    history.push(reverse(routes.privacyByDesign.new, { organizationSlug }))

  useEffect(() => {
    const delayRequest = setTimeout(
      () => setSearchParam(searchQuery),
      SEARCH_DELAY,
    )

    return () => clearTimeout(delayRequest)
  }, [searchQuery])

  return (
    <Page title="Privacy By Design">
      <Container maxWidth={false}>
        {/* Sem breadcrumbs: eles são resolvidos pelas rotas do app e não fazem
            sentido no portal, que tem só a listagem e o projeto. */}
        <ContentHeader title="Privacy By Design" historyBreadcumbs={false}>
          <Button
            id={PRIVACY_BY_DESIGN_TUTORIAL_STEP_2}
            variant="contained"
            color="primary"
            startIcon={<PlusCircleIcon size={20} />}
            onClick={redirectToCreate}
            fullWidth
          >
            Criar Projeto
          </Button>
          <Tooltip title="Iniciar o tour guiado">
            <Button
              id={PRIVACY_BY_DESIGN_TUTORIAL_STEP_1}
              variant="contained"
              color="primary"
              startIcon={<HelpCircleIcon size={20} />}
              onClick={() => setOpenTour(true)}
              fullWidth
            >
              Tutorial
            </Button>
          </Tooltip>
        </ContentHeader>
        <Box className={classes.searchRow}>
          <TextField
            id={PRIVACY_BY_DESIGN_TUTORIAL_STEP_4}
            placeholder="Pesquisar pelo nome do projeto"
            value={searchQuery}
            onChange={(event) => setSearchQuery(event.target.value)}
            variant="outlined"
            size="small"
            className={classes.searchInput}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <SearchIcon size={16} />
                </InputAdornment>
              ),
            }}
          />
        </Box>
        {/* O portal filtra pelo label do status, então usa as STATUS_LABEL_TABS.
            Os ids dos passos 3 e 5 ficam na tabela (abas e listagem). */}
        <Box id={PRIVACY_BY_DESIGN_TUTORIAL_STEP_3}>
          <PrivacyByDesignTable
            listService={service.guestPortal.privacyByDesign.list}
            tabs={constants.privacyByDesign.STATUS_LABEL_TABS}
            params={{ name: searchParam }}
            id={PRIVACY_BY_DESIGN_TUTORIAL_STEP_5}
            emptyMessage="Nenhum projeto encontrado."
            renderActions={(privacyByDesign, refresh) => (
              <ActionButtons
                privacyByDesign={privacyByDesign}
                refresh={refresh}
              />
            )}
          />
        </Box>
      </Container>
      <GuestDriveTour
        stepsMatrix={privacyByDesignTutorialSteps}
        open={openTour}
        setOpen={setOpenTour}
      />
    </Page>
  )
}

export default PrivacyByDesignList
